// extracted by css-extract-rspack-plugin
export default {"textBanner":"home-fragment__Banner_textBanner__VWEOy"};